import { registerBlockType } from '@wordpress/blocks';
import { Icon, box } from '@wordpress/icons';
import { Block } from './block';
import metadata from './block.json';

registerBlockType(metadata, {
	icon: {
		src: <Icon icon={box} />,
	},
	edit: Block,
	save: function(){},
});
